export const selectMyRecipesList = state => state.myrecipes.recipes;
export const getIsLoading = state => state.myrecipes.isLoading;